import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './TrustpilotBlock.styles';
const TrustpilotBlock = (props) => {
    return (React.createElement(S.Container, { id: props.id, "data-layout": props.layout === 'vertical' ? 'vertical' : 'horizontal' },
        props.url && React.createElement(S.Link, { href: props.url, target: "_blank" }),
        React.createElement(S.Logo, { alt: props.logo.altText, loading: "eager", role: props.logo.altText ? undefined : 'presentation', src: imageUrl(props.logo, { width: 144, heightratio: 36 / 144 }), width: "144", height: "36" }),
        React.createElement(S.RatingImage, { alt: props.starRating.altText, loading: "eager", role: props.starRating.altText ? undefined : 'presentation', src: imageUrl(props.starRating, { width: 256, heightratio: 48 / 256 }), width: "256", height: "48" }),
        React.createElement(S.RatingLabel, null,
            React.createElement("span", null, props.ratingLabel),
            React.createElement("strong", null,
                "\u2018",
                props.rating,
                "\u2019"))));
};
export default TrustpilotBlock;
